import { render } from "./AddRoomsSectionDataTable.vue?vue&type=template&id=11d0bf47"
import script from "./AddRoomsSectionDataTable.vue?vue&type=script&lang=js"
export * from "./AddRoomsSectionDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__